/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { selectTasksCountStat } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import SearchInput from 'components/Common/Inputs/SearchInput';
import {
  changeQueryParams,
  selectQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { t } from 'utils/translates';

class RightSidebarMyTasks extends Component {
  render() {
    const tasksExecsStatByAccTasks = this.props.tasksCountStat
      .tasksExecsStatByAccTasks;
    const activeCount =
      tasksExecsStatByAccTasks.countExecProcessed +
      tasksExecsStatByAccTasks.countExecAtCheckout +
      tasksExecsStatByAccTasks.countExecRemake +
      tasksExecsStatByAccTasks.countExecDispute;
    const notActiveCount =
      tasksExecsStatByAccTasks.countExecFinished +
      tasksExecsStatByAccTasks.countExecNotDone +
      tasksExecsStatByAccTasks.countExecCanceled +
      tasksExecsStatByAccTasks.countExecCanceledByTaskOwner;
    const totalCount = activeCount + notActiveCount;
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div
            aria-multiselectable="true"
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
          >
            <NavLink
              to={{
                pathname: '/my-tasks/executions/all',
                search: this.props.location.search
              }}
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">{totalCount}</span>
              <span
                className="list-group-item-val text-overflow"
                title={t('Все выполнения')}
              >
                {t('Все выполнения')}
              </span>
            </NavLink>
            <div className="list-group in">
              <NavLink
                to={{
                  pathname: '/my-tasks/executions/active',
                  search: this.props.location.search
                }}
                activeClassName="active"
                className="list-group-item"
              >
                <span className="badge">{activeCount}</span>
                <span
                  className="list-group-item-val text-overflow"
                  title={t('Активные')}
                >
                  {t('Активные')}
                </span>
              </NavLink>
              <div className="list-group-menu">
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/active/in-work',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecProcessed}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('В работе')}
                  >
                    {t('В работе')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/active/wait-checked',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecAtCheckout}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Ожидает проверки')}
                  >
                    {t('Ожидает проверки')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/active/remake',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecRemake}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Требует исправление')}
                  >
                    {t('Требует исправление')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/dispute',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  {tasksExecsStatByAccTasks.countExecDispute > 0 ? (
                    <span className="badge badge-danger">
                      {tasksExecsStatByAccTasks.countExecDispute}
                    </span>
                  ) : (
                    <span className="badge">
                      {tasksExecsStatByAccTasks.countExecDispute}
                    </span>
                  )}
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('В рассмотрении на арбитраже')}
                  >
                    {t('В рассмотрении на арбитраже')}
                  </span>
                </NavLink>
              </div>
            </div>
            <div className="list-group in">
              <NavLink
                to={{
                  pathname: '/my-tasks/executions/finished',
                  search: this.props.location.search
                }}
                activeClassName="active"
                className="list-group-item"
              >
                <span className="badge">{notActiveCount}</span>
                <span
                  className="list-group-item-val text-overflow"
                  title={t('Завершенные')}
                >
                  {t('Завершенные')}
                </span>
              </NavLink>
              <div className="list-group-menu">
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/finished/confirm',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecFinished}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Выполнен')}
                  >
                    {t('Выполнен')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/finished/cancel',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecNotDone}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Задание не выполнено')}
                  >
                    {t('Задание не выполнено')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname: '/my-tasks/executions/finished/refuse',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecCanceled}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Исполнитель отказался от работы')}
                  >
                    {t('Исполнитель отказался от работы')}
                  </span>
                </NavLink>
                <NavLink
                  to={{
                    pathname:
                      '/my-tasks/executions/finished/cancel-by-task-owner',
                    search: this.props.location.search
                  }}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="badge">
                    {tasksExecsStatByAccTasks.countExecCanceledByTaskOwner}
                  </span>
                  <span
                    className="list-group-item-val text-overflow"
                    title={t('Заказчик отменил выполнение')}
                  >
                    {t('Заказчик отменил выполнение')}
                  </span>
                </NavLink>
              </div>
            </div>
            <div className="border-t panel panel-default">
              <div className="panel-body">
                <div className="form-group form-group-sm">
                  <label
                    className="control-label control-label-light sr-only"
                    htmlFor="employerSearch"
                  >
                    {t('Фильтр по заказчикам')}
                  </label>
                  <div className="input-group">
                    <SearchInput
                      type="search"
                      className="form-control"
                      id="employerSearch"
                      placeholder={t('Фильтр по исполнителям')}
                      onChange={e => {
                        this.props.changeQueryParams({
                          execOwnerSearch: e.target.value
                        });
                        this.props.sendRequest();
                      }}
                      value={this.props.selectQueryParams.execOwnerSearch}
                    />
                    <span className="input-group-btn">
                      <button className="btn btn-sm btn-default" type="button">
                        <i className="fa fa-search" />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="form-group-sm">
                  <label
                    className="control-label control-label-light sr-only"
                    htmlFor="employerSearch"
                  >
                    {t('Фильтр по заказчикам')}
                  </label>
                  <div className="input-group">
                    <SearchInput
                      type="search"
                      className="form-control"
                      id="employerSearch"
                      placeholder={t('Фильтр по заданиям')}
                      onChange={e => {
                        this.props.changeQueryParams({
                          taskSearch: e.target.value
                        });
                        this.props.sendRequest();
                      }}
                      value={this.props.selectQueryParams.taskSearch}
                    />
                    <span className="input-group-btn">
                      <button className="btn btn-sm btn-default" type="button">
                        <i className="fa fa-search" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t panel panel-default">
              <div className="panel-body">
                <button
                  className="btn btn-block btn-muted btn-sm"
                  title="Сбрость фильтры"
                  tabIndex="0"
                  onClick={() => {
                    this.props.changeQueryParams({});
                    this.props.sendRequest();
                  }}
                >
                  {' '}
                  {t('Сбросить фильтры')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RightSidebarMyTasks.propTypes = {
  tasksCountStat: PropTypes.shape({
    tasksExecsStatByAccTasks: PropTypes.shape({
      countExecProcessed: PropTypes.number.isRequired,
      countExecAtCheckout: PropTypes.number.isRequired,
      countExecRemake: PropTypes.number.isRequired,
      countExecCanceled: PropTypes.number.isRequired,
      countExecNotDone: PropTypes.number.isRequired,
      countExecFinished: PropTypes.number.isRequired,
      countExecDispute: PropTypes.number.isRequired,
      countExecCanceledByTaskOwner: PropTypes.number.isRequired
    })
  }).isRequired,
  selectQueryParams: PropTypes.shape({
    execOwnerSearch: PropTypes.string,
    taskSearch: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  tasksCountStat: selectTasksCountStat(state),
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSidebarMyTasks);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/ExecutionsMyTasksList/rightSidebarMyTasks/RightSidebarMyTasks.js